import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import type { KnowledgeResponse } from "entities/knowledge/types";
import { fetchKnowledgeDataForTopicFailure, fetchKnowledgeDataForTopicSuccess } from "entities/knowledgeData/actions";
import type { KnowledgeDataFetchForTopicAction } from "entities/knowledgeData/actionTypes";
import { getPublicationFetchParams } from "entities/publication/sagas/utils";

export function* fetchKnowledgeDataForTopicSaga(action: KnowledgeDataFetchForTopicAction) {
  const { id } = action.payload;
  try {
    const payload: KnowledgeResponse[] = yield apiFetch(`topic/${id}/knowledge_data`, {
      queryParams: getPublicationFetchParams(action.payload),
      ...(action.meta.forceRefresh
        ? {
            headers: {
              "Cache-Control": "no-cache, no-store, must-revalidate",
            },
          }
        : {}),
    });

    yield put(fetchKnowledgeDataForTopicSuccess({ topicId: id, data: payload }, action.payload));
  } catch {
    yield put(fetchKnowledgeDataForTopicFailure({ logoutOnAuthError: true, searchCriteria: action.payload }));
  }
}
